module.exports = angular.module('msi.items', [
  'ui.router',
  require('@ordergroove/brandy/src/app/utils'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/modals'),
  require('@ordergroove/brandy/src/app/toasts')
]).name;

angular.module(module.exports)
  .service('itemService', require('./items.service'))
  .service('itemOrchestrator', require('./items.orchestrator'))
  .controller('RemoveItemController', require('./remove-item/remove-item.controller'))
  .component('ogRemoveItem', require('./remove-item/remove-item'));
